module.exports = __webpack_public_path__ + "brainstorm_icon.png?b3e1867b8bc81d7a48317736f81786bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-icons/brainstorm_icon.png
// module id = 7
// module chunks = 0